import React from 'react';
import LevelingRankPicker from './LevelingRankPicker';

export default class Leveling1to65 extends React.PureComponent {
    static minValue = 1;
    static maxValue = 65;

    static describeRank = rank => rank.toString();
    static getDefaultValue = () => [1, 30];

    static marks = {
        1: '1',
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        60: '60',
        65: '65',
    };

    render() {
        const { ...rest } = this.props;

        return (
            <LevelingRankPicker
                {...rest}
                min={Leveling1to65.minValue}
                max={Leveling1to65.maxValue}
                marks={Leveling1to65.marks}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/Leveling1to65.js